<template>
  <div>
    <b-modal
      id="modal-edit"
      size="lg"
      centered
      title="Edit Data Potongan"
      header-bg-variant="primary"
      header-text-variant="light"
    >
      <b-form>
        <b-form-group label=" Nama Potongan" label-cols-md="3">
          <b-form-input
            :state="checkIfValid('namaPotongan')"
            v-model="$v.data.namaPotongan.$model"
            @keydown.enter.prevent="simpan()"
          ></b-form-input>
        </b-form-group>
      </b-form>
      <b-form>
        <b-form-group label="Jenis Potongan" label-cols-md="3">
          <b-form-select
            disabled
            :options="jenis"
            :state="checkIfValid('jenisPotongan')"
            v-model="$v.data.jenisPotongan.$model"
            @keydown.enter.prevent="simpan()"
          ></b-form-select>
        </b-form-group>
      </b-form>

      <b-form>
        <b-form-group label="Nominal Potongan" label-cols-md="3">
          <b-form-input
            type="number"
            :disabled="data.jenisPotongan == 'Tidak Tetap'"
            :state="checkIfValid('nominalPotongan')"
            v-model="$v.data.nominalPotongan.$model"
            :placeholder="convert(data.nominalPotongan)"
            @keydown.enter.prevent="simpan()"
          ></b-form-input>
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button
          variant="secondary"
          @click="$bvModal.hide('modal-edit')"
        >
          {{ $store.state.form.batal }}
        </b-button>
        <b-button variant="primary" @click="simpan()" :disabled="!isValid"
          >Simpan</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, numeric, requiredIf } from "vuelidate/lib/validators";

export default {
  name: "modalInput",
  props: ["data"],
  data() {
    return {
      selected: null,
      busy: false,
      button: "Simpan",
      jenis: [
        { value: "", text: "Pilih Jenis Potongan" },
        { value: "Tetap", text: "Tetap" },
        { value: "Tidak Tetap", text: "Tidak Tetap" },
      ],
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this.data, null, 4);
    },
    isValid() {
      return !this.$v.data.$invalid;
    },
    isDirty() {
      return this.$v.data.$anyDirty;
    },
  },
  mixins: [validationMixin],
  validations: {
    data: {
      namaPotongan: {
        required,
      },
      jenisPotongan: {
        required,
      },
      nominalPotongan: {
        required: requiredIf(function () {
          return this.data.jenisPotongan == "Tetap";
        }),
        numeric,
      },
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    convert(x) {
      if (x) {
        return x.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
    },
    simpan() {
      let vm = this;
      if (vm.isValid) {
        vm.busy = true;
        vm.button = "Mohon Tunggu";
        vm.$axios
          .post("masterPotongan/update", vm.data)
          .then((res) => {
            if (res.data.message == "sukses") {
              vm.button = "Simpan";
              vm.busy = false;
              vm.$v.$reset();
              vm.$emit("alertFromChild", {
                variant: "success",
                msg: "BERHASIL MENDAFTARKAN MASTER POTONGAN",
                showing: true,
              });
              this.$bvModal.hide("modal-edit");
            } else {
              vm.button = "Simpan";
              vm.busy = false;
              vm.$emit("alertFromChild", {
                variant: "danger",
                msg: res.data.message.toUpperCase(),
                showing: true,
              });
            }
          })
          .catch((err) => {
            err;
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: "TERJADI KESALAHAN PADA SERVER",
              showing: true,
            });
          });
      }
    },
  },
};
</script>
